import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import style from "./MobileCompletionCard.module.css";
import Icon from "@/ui/icon/Icon";
import { SoundWaveIco } from "@/ui/icon/CustomIcons";
import { useFinishCourse } from "@/features/courses/hooks/useFinishCourse";
import { useConfettiWithSound } from "@/hooks/useConfettiWithSound";
import { useCourseCompletionContext } from "@/features/courses/hooks/useCourseCompletion";

function MobileMarkAsCompletedCard({ course }) {
	const { t } = useTranslation();
	const [clicked, setClicked] = useState(false);

	const { finishCourse } = useFinishCourse({ course });
	const { triggerConfetti, cleanup } = useConfettiWithSound();
	const { setShowCertificateToast } = useCourseCompletionContext();

	useEffect(() => {
		return () => {
			cleanup();
		};
	}, [cleanup]);

	const handleClick = async () => {
		if (clicked) return;

		setClicked(true);
		try {
			await Promise.all([finishCourse(), triggerConfetti()]);
			setShowCertificateToast(true);
		} catch (error) {
			console.error("Error:", error);
			setClicked(false);
		}
	};

	return (
		<div
			role="button"
			aria-disabled={clicked}
			onClick={handleClick}
			className={`${style.card} ${style.fadeIn} ${
				clicked ? style.disabled : ""
			}`}
		>
			<div className={style.iconBox}>
				<SoundWaveIco />
			</div>
			<div className={style.text}>
				<div className={style.subtitle}>
					{t("courses:mobileCompletion.lessonDone")}
				</div>
				<div className={style.title}>
					{t("courses:mobileCompletion.markWatched")}
				</div>
			</div>
			<div className={style.action}>
				<Icon icon="fa-check" />
			</div>
		</div>
	);
}

export default MobileMarkAsCompletedCard;
